import { render, staticRenderFns } from "./basicInfo.vue?vue&type=template&id=6ff01ac0&scoped=true"
import script from "./basicInfo.vue?vue&type=script&lang=js"
export * from "./basicInfo.vue?vue&type=script&lang=js"
import style0 from "./basicInfo.vue?vue&type=style&index=0&id=6ff01ac0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff01ac0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ff01ac0')) {
      api.createRecord('6ff01ac0', component.options)
    } else {
      api.reload('6ff01ac0', component.options)
    }
    module.hot.accept("./basicInfo.vue?vue&type=template&id=6ff01ac0&scoped=true", function () {
      api.rerender('6ff01ac0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/basicInfo.vue"
export default component.exports